import React from 'react'

import GETWebParams from '../../helpers/GETWebParams';
import { getPricesData as pricesData, getColorsData as colorsData } from '../../helpers/strapi.helper';
import { citiesData } from '../../data/cities.data';
import logocotiza from './../../UI/quotation/Logo_CotizaloAhora.svg'
import close from './../../UI/quotation/Close.svg'

interface Props {
  isQuotationOpened: boolean,
  currentCarSelected: string,
  currentModelSelected: string
  currentColorSelected: string,
  handleQuotation: (payload: boolean) => void
  handleCarStudioFromQuotation: (payload: boolean) => void
}

interface State {
  stepNumber: number,
  currentModelSelected: string
  currentModelPrice: string
  currentModelColor: string
  stepArray: Array<number>,
  currentLegal: boolean,
  currentName: string
  currentSurname: string
  currentCC: string,
  currentEmail: string,
  currentPhone: number,
  currentCity: string,
  currentOptionTime: string,
  currentLegalError: boolean,
  currentNameError: boolean,
  currentSurnameError: boolean,
  currentCCError: boolean,
  currentEmailError: boolean
  currentPhoneError: boolean,
  currentCityError: boolean,
}

declare const window: any;

class Quotation extends React.Component<Props, State>{
  constructor(props: Props) {
    super(props);
    this.state = {
      stepNumber: 0,
      currentModelSelected: '',
      currentModelPrice: '',
      currentModelColor: '',
      stepArray: [1, 1, 1],
      currentLegal: false,
      currentName: '',
      currentSurname: '',
      currentCC: '',
      currentEmail: '',
      currentPhone: 0,
      currentCity: '',
      currentOptionTime: 'Inmediata',
      currentLegalError: false,
      currentNameError: false,
      currentSurnameError: false,
      currentCCError: false,
      currentEmailError: false,
      currentPhoneError: false,
      currentCityError: false,
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if ((this.props.currentModelSelected !== prevProps.currentModelSelected) || (this.props.currentCarSelected !== prevProps.currentCarSelected)) {
      var prices: any = pricesData()
      this.setState({
        currentModelSelected: this.props.currentModelSelected,
        currentModelPrice: prices[this.props.currentCarSelected + " " + this.props.currentModelSelected]
      })
    }
    if ((this.props.currentModelSelected !== prevProps.currentModelSelected) || (this.props.currentCarSelected !== prevProps.currentCarSelected) || (this.props.currentColorSelected !== prevProps.currentColorSelected)) {
      var color = ''
      if (this.props.currentModelSelected !== '' && this.props.currentCarSelected !== '' && this.props.currentColorSelected !== '') {
        var colors: any = colorsData()
        var colorStruct = colors[this.props.currentCarSelected + " " + this.props.currentModelSelected]
        if (colorStruct && colorStruct[this.props.currentColorSelected]) {
          color = colorStruct[this.props.currentColorSelected].name
        }
      }
      if (color !== '') {
        this.setState({
          currentModelColor: color
        })
      }
    }
    if (this.props.isQuotationOpened !== prevProps.isQuotationOpened) {
      setTimeout(() => {
        this.setState({
          currentLegal: false,
          currentName: '',
          currentSurname: '',
          currentCC: '',
          currentEmail: '',
          currentPhone: 0,
          currentCity: '',
          stepNumber: 0,
          currentLegalError: false,
          currentNameError: false,
          currentSurnameError: false,
          currentCCError: false,
          currentEmailError: false,
          currentPhoneError: false,
          currentCityError: false,
        })
        var legals = document.getElementById('legal_terms_accept') as HTMLInputElement
        if(legals)
          legals.checked = false;
      }, 1000)
    }
  }

  handleLegalData = () => {
    console.log("checking legal data " + this.state.currentLegal)
    this.setState({
      currentLegalError: !this.state.currentLegal,
    }, () => {
      if (!this.state.currentLegalError) {
        this.setState({
          stepNumber: this.state.stepNumber + 1
        })
      }
    })
  }

  handleSentData = () => {
    if (!this.state.currentNameError && !this.state.currentSurnameError && !this.state.currentCCError && !this.state.currentEmailError && !this.state.currentPhoneError && !this.state.currentCityError) {
      window.sendQuotes(this.state.currentName, this.state.currentSurname, this.props.currentCarSelected,
        this.props.currentModelSelected, this.props.currentColorSelected, this.state.currentEmail,
        this.state.currentPhone, this.state.currentCity, this.state.currentCC, this.state.currentModelPrice)

      const params = GETWebParams()
      const utm_source = params.utm_source !== undefined ? params.utm_source : '';
      const utm_campaign = params.utm_campaign !== undefined ? params.utm_campaign : '';
      const utm_id = params.utm_id !== undefined ? params.utm_id : '';
      const utm_term = params.utm_term !== undefined ? params.utm_term : '';
      window.sendQuotesHyundai(this.state.currentName, this.state.currentSurname, this.props.currentCarSelected,
        this.props.currentModelSelected, this.props.currentColorSelected, this.state.currentEmail,
        this.state.currentPhone, this.state.currentCity, this.state.currentCC, this.state.currentModelPrice,
        utm_source, utm_campaign, utm_id, utm_term)
    }
  }

  handleValidateName = () => {
    this.setState({
      currentNameError: this.state.currentName === '',
    })
  }

  handleValidateSurname = () => {
    this.setState({
      currentSurnameError: this.state.currentSurname === '',
    })
  }

  handleValidateEmail = () => {
    this.setState({
      currentEmailError: !this.state.currentEmail.includes('@') || !this.state.currentEmail.includes('.'),
    })
  }

  handleValidateCC = () => {
    this.setState({
      currentCCError: this.state.currentCC === '',
    })
  }

  handleValidatePhone = () => {
    this.setState({
      currentPhoneError: this.state.currentPhone.toString().length !== 10 || !this.state.currentPhone.toString().startsWith('3'),
    })
  }

  handleValidateCity = () => {
    this.setState({
      currentCityError: this.state.currentCity === '',
    })
  }

  handleValidateData = () => {
    this.setState({
      currentNameError: this.state.currentName === '',
      currentSurnameError: this.state.currentSurname === '',
      currentEmailError: !this.state.currentEmail.includes('@') || !this.state.currentEmail.includes('.'),
      currentCCError: this.state.currentCC === '',
      currentPhoneError: this.state.currentPhone.toString().length !== 10 || !this.state.currentPhone.toString().startsWith('3'),
      currentCityError: this.state.currentCity === '',
    }, () => {
      if (!this.state.currentNameError && !this.state.currentSurnameError && !this.state.currentCCError && !this.state.currentEmailError && !this.state.currentPhoneError && !this.state.currentCityError) {
        this.setState({
          stepNumber: this.state.stepNumber + 1
        }, () => {
          this.handleSentData()
        })
      }
    })
  }

  render(): React.ReactNode {
    return (
      <div className={this.props.isQuotationOpened ? 'quotation-main-container-opened' : 'quotation-main-container-collapsed'}>
        <div className='quotation-header'>
          <div className='quotation-header-title'>
            &nbsp;
          </div>
          <div className='close-quotaiton-container' onClick={() => { this.props.handleQuotation(false) }}>
            <img src={close} alt='' />
          </div>
        </div>
        {
          <div className='steps-container'>
            {this.state.stepNumber === 0 ?
              <div className={this.state.stepNumber === 0 ? 'quotation-container first-step-container fade-in' : 'quotation-container first-step-container fade-out'}>
                <div className='quotation-main-logo'><img src={logocotiza} alt='' /></div>
                <div className='quotation-car-info-container'>
                  <div className='quotation-car-info-title'>{this.props.currentCarSelected}</div>
                  {/* {this.state.currentModelSelected + " - " + this.props.currentColorSelected} */}
                  <div className='quotation-car-info-color-model'>{this.state.currentModelColor}</div>
                </div>
                <div className='quotation-price-info'>
                  <div className='quotation-price-text'>Precio desde:</div>
                  <div className='quotation-price'>{this.state.currentModelPrice}*</div>
                </div>
                <div className='quotation-price-legal'>
                  <div className='quotation-price-legal-text'>* Los valores y precios publicados son de referencia y pueden variar sin previo aviso.</div>
                  <div className='quotation-price-legal-text'>* Las imágenes son ilustrativas, algunas características de los vehículos pueden variar.</div>
                </div>
                <div className='quotation-first-hr' />
                <div className={this.state.currentLegalError ? 'quotation-input-checkbox input-error' : 'quotation-input-checkbox'}>
                  <input id='legal_terms_accept' type='checkbox' onChange={(e: any) => { this.setState({ currentLegal: e.target.value }) }}></input>
                  <div className='quotation-checkbox-text'>
                    Acepto política de datos, términos y condiciones.
                  </div>
                </div>
                <div className='quotation-legal-text-container'>
                  <div className='quotation-legal-text'>
                    Estamos comprometidos con tu privacidad, por ello, en Hyundai Colombia S.A.S.
                    junto con nuestros aliados oficiales te aseguramos que utilizaremos la información que
                    nos proporcionas para comunicarnos contigo acerca de nuestros productos, servicios, ofertas,
                    invitaciones, encuestas, entre otras finalidades y contenidos relevantes para ti.
                    Puedes darte de baja de estas comunicaciones en cualquier momento. Para obtener más información
                    consulta nuestra <a href='https://www.hyundaicolombia.co/politica-proteccion-datos/' target='_blank' rel='noreferrer'>Política de privacidad.</a>
                  </div>
                </div>
              </div> : null

            }
            {this.state.stepNumber === 1 ?
              <div className={this.state.stepNumber === 1 ? 'quotation-container first-step-container fade-in' : 'quotation-container first-step-container fade-out'}>
                <div className='quotation-main-logo'><img src={logocotiza} alt='' /></div>
                <div className='quotation-input-container'>
                  <div className={this.state.currentNameError ? 'quotation-input-name name-error' : 'quotation-input-name'}>Nombre</div>
                  <input className={this.state.currentNameError ? 'quotation-input input-error' : 'quotation-input'} type='text' onChange={(e: any) => { this.setState({ currentName: e.target.value }, () => { this.handleValidateName() }) }}></input>
                  <div className='warning-text-quotation'>{this.state.currentNameError ? "Este campo es obligatorio." : ""}</div>
                </div>
                <div className='quotation-input-container'>
                  <div className={this.state.currentSurnameError ? 'quotation-input-name name-error' : 'quotation-input-name'} >Apellido</div>
                  <input className={this.state.currentSurnameError ? 'quotation-input input-error' : 'quotation-input'} type='text' onChange={(e: any) => { this.setState({ currentSurname: e.target.value }, () => { this.handleValidateSurname() }) }}></input>
                  <div className='warning-text-quotation'>{this.state.currentSurnameError ? "Este campo es obligatorio." : ""}</div>
                </div>
                <div className='quotation-input-container'>
                  <div className={this.state.currentEmailError ? 'quotation-input-name name-error' : 'quotation-input-name'}>Correo</div>
                  <input className={this.state.currentEmailError ? 'quotation-input input-error' : 'quotation-input'} type='text' onChange={(e: any) => { this.setState({ currentEmail: e.target.value }, () => { this.handleValidateEmail() }) }}></input>
                  <div className='warning-text-quotation'>{this.state.currentEmailError ? "Por favor ingresa un correo electrónico válido." : ""}</div>
                </div>
                <div className='quotation-input-container'>
                  <div className={this.state.currentCCError ? 'quotation-input-name name-error' : 'quotation-input-name'}>Cédula</div>
                  <input className={this.state.currentCCError ? 'quotation-input input-error' : 'quotation-input'} type='text' onChange={(e: any) => { this.setState({ currentCC: e.target.value }, () => { this.handleValidateCC() }) }}></input>
                  <div className='warning-text-quotation'>{this.state.currentCCError ? "Este campo es obligatorio." : ""}</div>
                </div>
                <div className='quotation-input-container'>
                  <div className={this.state.currentPhoneError ? 'quotation-input-name name-error' : 'quotation-input-name'}>Celular</div>
                  <input className={this.state.currentPhoneError ? 'quotation-input input-error' : 'quotation-input'} type='number' onChange={(e: any) => { this.setState({ currentPhone: e.target.value }, () => { this.handleValidatePhone() }) }}></input>
                  <div className='warning-text-quotation'>{this.state.currentPhoneError ? "Por favor ingresa un número válido." : ""}</div>
                </div>

                <div className='quotation-input-container'>
                  <div className={this.state.currentCityError ? 'quotation-input-name name-error' : 'quotation-input-name'}>Ciudad</div>
                  <select className={this.state.currentCityError ? 'quotation-select input-error' : 'quotation-select'} defaultValue='' onChange={(e: any) => { this.setState({ currentCity: e.target.value }, () => { this.handleValidateCity() }) }}>
                    <option key='' value={''}>Seleccionar</option>
                    {
                      Object.keys(citiesData()).map((key: string) => (
                        <option key={key} value={key}>{key}</option>
                      ))
                    }
                  </select>
                  <div className='warning-text-quotation'>{this.state.currentCityError ? "Por favor selecciona tu ubicación." : ""}</div>
                </div>
                {/* {
                  this.state.currentNameError || this.state.currentSurnameError || this.state.currentCityError || this.state.currentEmailError || this.state.currentPhoneError ?
                    <div className='warning-text-quotation'>Los campos señalados son obligatorios.</div> : null
                } */}
              </div> : null
            }


            {this.state.stepNumber === 2 ?
              <div className={this.state.stepNumber === 2 ? 'quotation-container first-step-container fade-in' : 'quotation-container first-step-container fade-out'}>
                <div className='quotation-finish-title'>Ya estás más cerca de tener tu nuevo Hyundai</div>
                <div className='quotaiton-finish-text'>Gracias por escogernos. Pronto un asesor se contactará contigo.</div>
                <div className='quotation-finish-btn1' onClick={() => { this.props.handleQuotation(false) }}>CERRAR COTIZACIÓN</div>
                <div className='quotation-finish-btn2' onClick={() => { this.props.handleCarStudioFromQuotation(true) }}>VER MÁS VEHÍCULOS</div>
              </div> : null
            }

            <div className='quotation_progress_container'>

              {this.state.stepNumber !== 2 ?
                <div className='quotation-continue-btn' onClick={() => {
                  console.log(this.state.stepNumber)
                  if (this.state.stepNumber === 0) {
                    this.handleLegalData()
                  } else if (this.state.stepNumber === 1) {
                    this.handleValidateData()
                  }
                  else {
                    this.setState({ stepNumber: this.state.stepNumber + 1 },
                      () => {
                        if (this.state.stepNumber === 3) {
                          this.props.handleQuotation(false);
                          setTimeout(() => { this.setState({ stepNumber: 0 }); }, 500)
                        }
                      })
                  }
                }}>{this.state.stepNumber === 0 ? 'CONTINUAR' : this.state.stepNumber === 1 ? 'FINALIZAR' : 'CERRAR COTIZACIÓN'}
                </div> : null
              }

              {
                <div className='current-quotation-step-container'>
                  {
                    this.state.stepArray.map((items: any, index: number) =>
                      <div className={this.state.stepNumber === index ? 'selected-step step-quotation' : 'step-quotation'} />
                    )
                  }
                </div>
              }
            </div>


          </div>
        }
      </div>
    )
  }
}

export default Quotation